// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;The Lord himself watches over you;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the Lord is your shade at your right hand,<br> </p> </div></div>";
// Exports
module.exports = code;